<template>
    <div>
       <div class="header" id="header">
      <div class="header-con">
        <div class="header-nav">
          <div class="header-nav-con">
            <ul class="header-nav-type">
              <li>
               <span @click="handleClick('mtzx')">北京麦田</span>
              </li>
              <li>
                <span @click="handleClick('fzmt')">福州麦田</span>  
              </li>
              <li>
                <span @click="handleClick('xmmt')">厦门麦田</span>
              </li>
            </ul>
            <ul class="header-nav-func">
              <!-- <li @click="handleQuestion">
                <img src="../assets/5.png" alt="">
                <span>问卷调查</span>
              </li> -->
              <li @click="handleClick('zc')">
                <img src="../assets/4.png" alt="">
                <span>员工注册</span>
              </li>
              <li  @click="handleClick('gp')">
                <img src="../assets/2.png" alt="">
                <span>公盘登录</span>
              </li>
              <li @click="handleClick('zcdy')">
                <img src="../assets/6.png" alt="">
                <span>注册打印</span> 
              </li>
              <li @click="handleClick('qyyx')">
                <img src="../assets/1.png" alt="">
                <span>企业邮箱</span> 
              </li>
            </ul>
          </div>
          
        </div>
        <!-- <div class="header-menu">
          <div class="header-menu-con">
            <img src="../assets/maitianlogo.png" alt="" @click="handleClick('mt')">
            <ul class="menu">
              <li  @click="handleClick('sy')">首页</li>
              <li  @click="handleClick('ljmt')">了解麦田</li>
              <li  @click="handleClick('fyrw')">风云人物</li>
              <li  @click="handleClick('cpyc')">诚聘英才</li>
              <li   @click="handleClick('jyts')">投诉建议</li>
              <li  @click="handleClick('mtff')">麦田服务</li>
              <li  @click="handleClick('mjj')">麦基金</li>
            </ul>
          </div>
        </div> -->
      </div>
    </div>
    <div class="header-iframe"></div>
    <a-modal v-model="visible" title="Basic Modal">
     1111
    </a-modal>
  </div>
  
</template>
<script>
import HLink from '../constant/headerLink'
export default {
    data(){
      return {
        visible: false
      }
    },
    methods: {
        handleClick(type){
            window.location.href = HLink[type]
        },
        handleQuestion(){
          this.visible = true
        }
    }
}
</script>
<style lang="less" scoped>
 .header{
      box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.06);
      position: fixed;
      z-index: 5020;
      left: 0;
      top:0;
      width: 100vw;
      background-color: #ffffff;
      &-iframe{
        // height: 138px;
        height: 40px;
      }
    }
    .header .header-con{
     
    }
    .header .header-nav{
      height: 38px;
      background-color: #555555;
    }
    .header .header-nav-con{
      width: 1200px;
      margin: 0 auto;
      display: flex;
      height: 38px;
      align-items: center;
      justify-content: space-between;
    }
    .header .header-nav-type{
      list-style: none;
      padding: 0;
      margin: 0;
      display: flex;
      color: #ffffff;
    }
    .header .header-nav-type>li{
      margin-right: 25px;
      position: relative;
      line-height: 1;
      font-size: 14px;
    }
    .header .header-nav-type span{
      opacity: 0.6;
    }
    .header .header-nav-type span:hover{
      cursor: pointer;
      color: #ffffff;
      opacity: 1;
    }
    .header .header-nav-type>li::after{
      content: '';
      position: absolute;
      width: 1px;
      height: 13px;
      background-color: rgba(153, 153, 153, 0.6);
      top:50%;
      transform: translate(0,-50%);
      right: -13px;
    }
    .header .header-nav-type>li:last-child::after{
      display: none;
    }
    .header .header-nav-func{
      list-style: none;
      padding: 0;
      margin: 0;
      display: flex;
      font-size: 14px;
    }
    .header .header-nav-func li{
      display: flex;
      align-items: center;
      margin-left: 36px;
      color: #ffffff;
      cursor: pointer;
      opacity: 0.6;
    }
    .header .header-nav-func img{
      width: 16px;
      height: 16px;
      margin-right: 6px;
    }
    .header .header-nav-func li:hover{
      opacity: 1;
    }
    .header .header-menu {
     
    }
    .header .header-menu-con{
      width: 1200px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 100px;
    }
    .header .header-menu img{
      width: 89px;
      cursor: pointer;
    }
    .header .header-menu .menu{
      list-style: none;
      margin: 0;
      padding: 0;
      display: flex;
    }
    .header .header-menu li{
      font-size: 20px;
      margin-left: 60px;
      font-weight: 500;
      color: #000000;
      cursor: pointer;
      position: relative;
    }
    .header .header-menu li::after{
      content: '';
      width: 100%;
      height: 2px;
      background-color: #ffc029;
      position: absolute;
      bottom: -6px;
      left: 0;
      visibility: hidden;
      transform: scaleX(0);
    }
    .header .header-menu li:hover:after{
      visibility: inherit;
      transition: all .2s ease-in-out 0s;
      transform: scaleX(1);
    }
</style>